var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStoreIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2642_16331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.375 10.3149V15.125C3.375 15.2742 3.43426 15.4173 3.53975 15.5228C3.64524 15.6283 3.78832 15.6875 3.9375 15.6875H14.0625C14.2117 15.6875 14.3548 15.6283 14.4602 15.5228C14.5657 15.4173 14.625 15.2742 14.625 15.125V10.3149",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79688 3.3125H14.2031C14.3253 3.31252 14.4442 3.35233 14.5417 3.42591C14.6393 3.49949 14.7102 3.60283 14.7438 3.72031L15.6774 6.99517C15.7107 7.11205 15.7273 7.17049 15.6973 7.21024C15.6673 7.25 15.6066 7.25 15.485 7.25H2.51513C2.39354 7.25 2.33274 7.25 2.30273 7.21022C2.27273 7.17044 2.28943 7.11198 2.32282 6.99507L3.25828 3.72031C3.29178 3.60318 3.36241 3.50009 3.45954 3.42655C3.55667 3.353 3.67505 3.31298 3.79688 3.3125Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.25V8.375C6.75 8.97174 6.51295 9.54403 6.09099 9.96599C5.66903 10.3879 5.09674 10.625 4.5 10.625C3.90326 10.625 3.33097 10.3879 2.90901 9.96599C2.48705 9.54403 2.25 8.97174 2.25 8.375V7.25",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.25V8.375C11.25 8.97174 11.0129 9.54403 10.591 9.96599C10.169 10.3879 9.59674 10.625 9 10.625C8.40326 10.625 7.83097 10.3879 7.40901 9.96599C6.98705 9.54403 6.75 8.97174 6.75 8.375V7.25",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.25V8.375C15.75 8.97174 15.5129 9.54403 15.091 9.96599C14.669 10.3879 14.0967 10.625 13.5 10.625C12.9033 10.625 12.331 10.3879 11.909 9.96599C11.4871 9.54403 11.25 8.97174 11.25 8.375V7.25",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2642_16331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon);
export default __webpack_public_path__ + "static/media/store-icon.6be8050e.svg";
export { ForwardRef as ReactComponent };